module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--space-audio-settings2d19d285d6ed2448e1e24931449ed67e.svg";